let arr=[
    {name:'省级',value:'省级'},
    {name:'市级',value:'市级'},
    {name:'区县级',value:'区县级'}
]
export default arr